import {TEAL_300, TEAL_600} from '@wandb/weave/common/css/color.styles';
import {hexToRGB} from '@wandb/weave/common/css/utils';
import {IconLightbulbInfo} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Circle = styled.div`
  border-radius: 50%;
  width: 96px;
  height: 96px;
  background-color: ${hexToRGB(TEAL_300, 0.48)};
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
`;

export const LightBulb = styled(IconLightbulbInfo)`
  width: 36px;
  height: 48px;
  color: ${TEAL_600};
`;
